import connector from "./connector";
import TimeSelect from "./TimeSelect";

export default connector(TimeSelect);



// WEBPACK FOOTER //
// ./src/components/TimeSelect/index.js